import { proactiveWelcome } from './proactive-welcome';
import { contactForm2 } from './contact-form-2';
import { exitIntentOffer } from './exit-intent-offer';
import { demoScheduler } from './demo-scheduler';
import { coldOutreach } from './cold-outreach';

// Export all lead capture playbooks
export const leadCapturePlaybooks = [
  proactiveWelcome,
  contactForm2,
  exitIntentOffer,
  demoScheduler,
  coldOutreach,
];

// Export individual playbooks for direct import
export { 
  proactiveWelcome,
  contactForm2,
  exitIntentOffer,
  demoScheduler,
  coldOutreach
};